import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { _ActaComiteBank } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Modal } from "../../../../theme/Component/Modal";
import AutoChart from "../../../../../core/graph/AutoChart";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../theme/Component/DropDown";


interface Props {
    IDActaComite: number;
}


export const ActaComiteBank = ({ IDActaComite }: Props) => {

    const ActaComiteBank = useDataBean(_ActaComiteBank);

    const modalGraph = useModal("Grafica", MODAL_LG);

    const [lista, setLista] = useState<any>([]);

    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [IDActaComite])

    const getLista = () => {

        ActaComiteBank.instance.getActaComiteBank(paginador.page, 2000, { IDActaComite: IDActaComite }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }


    const head = [
        { title: 'ID', property: 'IDActaComite', visible: false },
        { title: 'IDAcc', property: 'IDAccount', visible: true },
        { title: 'Cedula', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'EntityName', visible: true },
        { title: 'Banco', property: 'NameBank', visible: true },
        { title: 'Cuenta', property: 'AccountNumber', visible: true },
        { title: 'Tipo Cuenta', property: 'AccountType', visible: true },
        { title: 'Desembolso', property: 'Amount', visible: true, mask: MASK_MONEY },
        { title: 'Linea Credito', property: 'NameLoanLine', visible: true },

    ]
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }


    return (
        <BasicPage titulo="Bancos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={ActaComiteBank.setBean}></BasicTable>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['NameBank', 'NameLoanLine', 'AccountType']}
                            yOptions={['Amount']} />

                    </Modal>

                </div>

            </div>
        </BasicPage>
    )
}